module.exports = __webpack_public_path__ + "static/img/left-num-row-2.a609ad6e.png";